import React from 'react';
import { SendIcon } from '@features/sidebar/components/sidebar-icons/components/send-icon/SendIcon';

export const SidebarIcons = {
  sendIcon: <SendIcon />,
};
